<template>
  <div class="section-header">
    <div v-if="icon" class="section-icon">
      <i :class="icon"></i>
    </div>
    <h2 class="section-title">{{ title }}</h2>
    <p v-if="subtitle" class="section-subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2a5298;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(42, 82, 152, 0.25);
}

.section-icon i {
  font-size: 2.5rem;
  color: #ffffff;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1f3a;
  margin-bottom: 12px;
  letter-spacing: -0.02em;
}

.section-subtitle {
  font-size: 1.125rem;
  color: #6b7280;
  margin: 0;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }
  
  .section-icon {
    width: 64px;
    height: 64px;
  }
  
  .section-icon i {
    font-size: 2rem;
  }
}
</style>

